import { render, staticRenderFns } from "./DiscountCardsTable.vue?vue&type=template&id=1bcd0b98"
import script from "./DiscountCardsTable.vue?vue&type=script&lang=js"
export * from "./DiscountCardsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports